/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "LocationFormRest",
            "endpoint": "https://ar9i4qcvcf.execute-api.us-east-1.amazonaws.com/lvpsep",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:7d230918-a2fa-4770-b3c5-fd60b11384e9",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_MHPWu92Aw",
    "aws_user_pools_web_client_id": "7lk63tmic1mcufirer68npsigu",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "geo": {
        "amazon_location_service": {
            "region": "us-east-1",
            "search_indices": {
                "items": [
                    "locationform-lvpsep"
                ],
                "default": "locationform-lvpsep"
            }
        }
    }
};


export default awsmobile;
